import React from "react";
import BillingField from "./BillingField";
import { Checkbox, FormControlLabel, Select, MenuItem } from "@material-ui/core";
import { IBillingValues, SelectItem } from "../types/locationTypes";
import CommonRow from "./CommonRow";
import { useStylesForForms } from "./billingHelpers";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

interface BillingFormType3Props {
  billingValuesObj: IBillingValues;
  handleSetBillingValuesObj: any;
  disabled: boolean;
  cancellationIntervals: SelectItem[];
  retainerIntervals: SelectItem[];
}

const BillingFormType3: React.FC<BillingFormType3Props> = ({
  billingValuesObj,
  handleSetBillingValuesObj,
  disabled,
  cancellationIntervals,
  retainerIntervals,
}) => {
  const classes = useStylesForForms();
  return (
    <>
      <div className={classes.flexContainer}>
        <div>
          <hr className={classes.separator} />
        </div>
        <div className={classes.row}>
          <BillingField
            title="TRANSFERS 1-20 ($)"
            description=""
            parentClasses={classes}
            disabled={disabled}
            value={billingValuesObj.week20TransfersFees}
            setValue={(newValue: string | null) => handleSetBillingValuesObj("week20TransfersFees", newValue)}
          />
          <BillingField
            title="TRANSFERS 21-25 ($)"
            description=""
            parentClasses={classes}
            disabled={disabled}
            value={billingValuesObj.week25TransfersFees}
            setValue={(newValue: string | null) => handleSetBillingValuesObj("week25TransfersFees", newValue)}
          />
          <BillingField
            title="TRANSFERS 26-30 ($)"
            description=""
            parentClasses={classes}
            disabled={disabled}
            value={billingValuesObj.week30TransfersFees}
            setValue={(newValue: string | null) => handleSetBillingValuesObj("week30TransfersFees", newValue)}
          />
          <BillingField
            title="TRANSFERS 31-35 ($)"
            description=""
            parentClasses={classes}
            disabled={disabled}
            value={billingValuesObj.week36TransfersFees}
            setValue={(newValue: string | null) => handleSetBillingValuesObj("week36TransfersFees", newValue)}
          />
          <BillingField
            title="TRANSFERS 36+ ($)"
            description=""
            parentClasses={classes}
            disabled={disabled}
            value={billingValuesObj.week36OverTransfersFees}
            setValue={(newValue: string | null) => handleSetBillingValuesObj("week36OverTransfersFees", newValue)}
          />
        </div>
        <div>
          <hr className={classes.separator} />
        </div>
        <div className={classes.flexContainer} style={{ paddingLeft: 10 }}>
          <FormControlLabel
            control={
              <Checkbox
                style={{ padding: 4 }}
                disableRipple
                disabled={disabled}
                checked={billingValuesObj.applyCancellationFees === true}
                onChange={(e: React.ChangeEvent<any>) => {
                  handleSetBillingValuesObj("applyCancellationFees", e.target.checked);
                }}
              />
            }
            label="Apply cancellation fee (equal to transfer charge) if transfer cancelled within..."
          />
          <div className={classes.row} style={{ paddingLeft: 30 }}>
            <div>
              <div style={{ width: 230, margin: "10px 0px" }}>
                <Select
                  onChange={(e) => {
                    handleSetBillingValuesObj("cancellationPeriod", e.target.value);
                  }}
                  fullWidth={true}
                  value={billingValuesObj.cancellationPeriod}
                  displayEmpty
                  IconComponent={KeyboardArrowDownIcon}
                  defaultValue=""
                  variant="outlined"
                >
                  {cancellationIntervals.map((item) => (
                    <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>
                      {item.text}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className={classes.formDescr}>...of scheduled pickup time</div>
            </div>

          </div>
        </div>
        <div>
          <hr className={classes.separator} />
        </div>
        <CommonRow
          billingValuesObj={billingValuesObj}
          handleSetBillingValuesObj={handleSetBillingValuesObj}
          disabled={disabled}
          parentClasses={classes}
          retainerIntervals={retainerIntervals}
        />
      </div>
    </>
  );
};

export default BillingFormType3;
